import React, { useState } from 'react';
import { MDBContainer, MDBInput, MDBBtn, MDBCard, MDBCardBody, MDBIcon } from 'mdb-react-ui-kit';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from './header';
import Footer from './footer';

const ChangePassword = () => {

    const esTemporal = localStorage.getItem('mustChangePassword') === 'true';

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    oldPassword: esTemporal ? 'cambia_tu_contraseña' : '',
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);

 const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.newPassword !== formData.confirmPassword) {
      return Swal.fire('Error', 'Las nuevas contraseñas no coinciden', 'error');
    }

    if (formData.newPassword.length < 6) {
      return Swal.fire('Atención', 'La nueva contraseña debe tener al menos 6 caracteres', 'warning');
    }

    setLoading(true);
    try {
      const res = await axios.post('/api/auth/change-password', {
        // Asegúrate de enviar la contraseña actual correcta
        oldPassword: formData.oldPassword, 
        newPassword: formData.newPassword
      }, { withCredentials: true });

      if (res.data.success) {
        // --- ACTUALIZAMOS EL LOCALSTORAGE PARA QUE YA NO SEA TEMPORAL ---
        localStorage.setItem('mustChangePassword', 'false');

        await Swal.fire({
          title: res.data.primeraVez ? '¡Cuenta Activada!' : '¡Éxito!',
          text: 'Tu contraseña ha sido actualizada correctamente.',
          icon: 'success',
          confirmButtonColor: '#2b2b2b'
        });

        setFormData({ oldPassword: '', newPassword: '', confirmPassword: '' });
        
        // Redirección final
        navigate(res.data.primeraVez ? '/agenda' : '/agenda'); 
      }
    } catch (err) {
      // Si el error es 401, probablemente la oldPassword no coincide con "cambia_tu_contraseña"
      console.error("Error en el cambio:", err.response?.data);
      Swal.fire({
        title: 'Error',
        text: err.response?.data?.error || 'Contraseña actual incorrecta',
        icon: 'error',
        confirmButtonColor: '#2b2b2b'
      });
    } finally {
      setLoading(false);
    }
};

  return (
    <>
    <Header active="Inicio"></Header>
    <MDBContainer className="py-5 d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <MDBCard style={{ maxWidth: '450px', width: '100%', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
        <MDBCardBody className="p-4">
          <div className="text-center mb-4">
            <MDBIcon fas icon="user-shield" size="3x" className="mb-3" style={{ color: '#2b2b2b' }} />
            <h4 className="fw-bold">Seguridad de la Cuenta</h4>
            <p className="text-muted small">Actualiza tus credenciales de acceso</p>
          </div>

          <form onSubmit={handleSubmit}>
            <MDBInput 
              label='Contraseña Actual o Temporal' 
              type='password' 
              wrapperClass='mb-4'
              value={formData.oldPassword}
              onChange={(e) => setFormData({...formData, oldPassword: e.target.value})}
              required
            />
            
            <div className="text-muted mb-2 small">Nueva contraseña:</div>
            
            <MDBInput 
              label='Nueva Contraseña' 
              type='password' 
              wrapperClass='mb-4'
              value={formData.newPassword}
              onChange={(e) => setFormData({...formData, newPassword: e.target.value})}
              required
            />
            <MDBInput 
              label='Confirmar Nueva Contraseña' 
              type='password' 
              wrapperClass='mb-4'
              value={formData.confirmPassword}
              onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
              required
            />

            <MDBBtn 
              type='submit' 
              block 
              disabled={loading}
              style={{ backgroundColor: '#2b2b2b', height: '45px', textTransform: 'none', fontSize: '16px' }}
            >
              {loading ? 'Procesando...' : 'Guardar Cambios'}
            </MDBBtn>
          </form>
        </MDBCardBody>
      </MDBCard>
    </MDBContainer>
    <Footer></Footer>
    </>
  );
};

export default ChangePassword;